import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../../core'
import * as stakeholder from '../stakeholder'

export const RESOURCE = {
  payload: {
    canBeOptional: true,
    context: core.dms.models.Attribute.Id.Context.from({
      context: stakeholder.RESOURCE.payload.dimension.partialId,
      partialId: stakeholder.RESOURCE.payload.partialId,
      type: core.dms.models.Type.Entity,
    }),
    description:
      "The stakeholder's anticipated system or user role in the future-state solution.",
    isOptional: true,
    name: 'System / User Role',
    partialId: PartialId.Standard.create('system_user_role'),
    type: core.common.value.types.Intrinsic.Text,
  },
  type: core.quiver.Resource.Type.DmsAttribute,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsAttribute>
